import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"10px","text-align":"left"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"padding":"20px"} }

import { ref, reactive, toRefs } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allDomainname,addDomainname,delDomainname,allPlatform} from '../../api'
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'domainName',
  setup(__props) {

  const visible11 = ref(false); 

  const selectedKeys = ref([]);
  
  const dataSource = ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const columns = ref([
    { title: "序号", key: "id", align: "center" },
    { title: "域名", key: "domainName", align: "center"}, 
    { title: "绑定平台", key: "platformId", align: "center",customSlot: "platform" },  
    { title: "备注", key: "remark", align: "center" },
    { title: "添加时间", key: "addTime", align: "center" },
    { title: "操作", customSlot: "operator", key: "operator", fixed: "right", align: "center" }
  ]);
  

  const platformArr = ref([]);

  const getAllPlatform = () => {
    var data = { "page":1, "limit": 200};
    allPlatform(data).then((res: any) => {
      if (res != "" && res.code == 0) {
        platformArr.value = res.data; 
      } else {
        platformArr.value = []; 
      }
      getAllDomainname();
    })
  }
  getAllPlatform();

  
  const getAllDomainname = () => {
    var data = { "page": page.current, "limit": page.limit};
    allDomainname(data).then((res: any) => {
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
   
  
  const domainname = reactive({
    id:0,
    domainName: "",
    platformId: "",
    remark: "",
   
  })
  
  const changeVisible11 = () => {
    domainname.id=0,
    domainname.domainName="",
    domainname.platformId="", 
    domainname.remark="", 
    visible11.value = !visible11.value;
  }
  
  const updateDomainname = (row: any) => {
    domainname.id=row.id,
    domainname.domainName=row.domainName,
    domainname.platformId=row.platformId,
    domainname.remark= row.remark, 
    visible11.value = !visible11.value;
  }
  
  
  const action11 = ref([
    {
      text: "确认",
      callback: () => {
        addDomainname(JSON.stringify(domainname)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllDomainname();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
      }
    },
    {
      text: "取消",
      callback: () => {
        visible11.value = false; 
      }
    }
  ])
  
   
  const deleteDomainname=(row:any,)=>{
    var data={'id':row.id} 
    delDomainname(JSON.stringify(data)).then((res: any) => {
          if (res != "" && res.code == 0) {
            getAllDomainname();
            visible11.value = false;
            layer.msg("操作成功", { time: 1000, icon: 1 });
          }
        })
  
  }
  
  
   
  const getPlatformName=(id:any,)=> {
      const platform = platformArr.value.find(item => item.id == id);
      return platform ? platform.name : '未知平台';
    }
   
  
return (_ctx: any,_cache: any) => {
  const _component_lay_button = _resolveComponent("lay-button")!
  const _component_lay_table = _resolveComponent("lay-table")!
  const _component_lay_panel = _resolveComponent("lay-panel")!
  const _component_lay_row = _resolveComponent("lay-row")!
  const _component_lay_input = _resolveComponent("lay-input")!
  const _component_lay_form_item = _resolveComponent("lay-form-item")!
  const _component_lay_select_option = _resolveComponent("lay-select-option")!
  const _component_lay_select = _resolveComponent("lay-select")!
  const _component_lay_textarea = _resolveComponent("lay-textarea")!
  const _component_lay_form = _resolveComponent("lay-form")!
  const _component_lay_layer = _resolveComponent("lay-layer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_lay_row, { space: "10" }, {
      default: _withCtx(() => [
        _createVNode(_component_lay_panel, { style: {"padding":"10px"} }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_lay_button, {
                size: "sm",
                onClick: changeVisible11,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_lay_table, {
              height: '100%',
              columns: columns.value,
              "data-source": dataSource.value,
              "selected-keys": selectedKeys.value,
              "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((selectedKeys).value = $event))
            }, {
              operator: _withCtx(({ row }) => [
                _createVNode(_component_lay_button, {
                  size: "xs",
                  type: "primary",
                  onClick: ($event: any) => (updateDomainname(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_lay_button, {
                  size: "xs",
                  type: "danger",
                  onClick: ($event: any) => (deleteDomainname(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              platform: _withCtx(({ row }) => [
                (getPlatformName(row.platformId))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(getPlatformName(row.platformId)), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source", "selected-keys"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_lay_layer, {
      modelValue: visible11.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible11).value = $event)),
      shade: false,
      area: ['380px', '400px'],
      btn: action11.value,
      title: "添加域名/修改域名"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_lay_form, {
            model: domainname,
            ref: "layFormRef11"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lay_form_item, {
                label: "域名",
                prop: "domainName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_input, {
                    modelValue: domainname.domainName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((domainname.domainName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "绑定平台",
                prop: "platformId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_select, {
                    modelValue: domainname.platformId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((domainname.platformId) = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(platformArr.value, (platform) => {
                        return (_openBlock(), _createBlock(_component_lay_select_option, {
                          key: platform.id,
                          value: String(platform.id),
                          label: platform.name
                        }, null, 8, ["value", "label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_lay_form_item, {
                label: "备注",
                prop: "remark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lay_textarea, {
                    placeholder: "请输入备注",
                    modelValue: domainname.remark,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((domainname.remark) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "btn"])
  ], 64))
}
}

})